export default "__VITE_PUBLIC_ASSET__fb298361__"